<template>
  <div class="fourth-bar">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list"
        :key="item.id"
        class="grid__item"
      >
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__img">
            <ImageContainer
              class="img"
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
          </div>
          <div class="card__descr">
            <span class="card__category">{{ item.sub_category.name }}</span>
            <h3 class="card__title limited-text">{{ item.title }}</h3>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }}</span>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },

  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.fourth-bar {
  width: 100%;
  margin: 5rem 0;
}
.grid {
  width: 90%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1.5vw;
  &__item {
    grid-column: span 6;
  }
}

.card {
  position: relative;
  height: 33vw;
  display: flex;
  flex-direction: column;
  width: 100%;
  &__img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
  }
  &__descr {
    width: 100%;
    margin-top: auto;
    padding: 1rem 6vw;
    min-height: calc(min(127px, 9vw));
    background: rgba(18, 18, 18, 0.6);
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  &__category {
    font-size: 1.125em;
  }
  &__title {
    --snup: 2;
    font-size: 1.3em;
    line-height: 1.3;
  }
  .data-news {
    margin-top: 0.5rem;
  }
}

@media screen and (max-width: 992px) {
  .grid {
    grid-template-columns: repeat(6, 1fr);
    gap: 2rem;
    &__item {
      grid-column: span 6;
    }
  }
  .card {
    display: flex;
    flex-direction: row;
    &__img {
      flex: 0 0 50%;
      position: relative;
      z-index: 0;
    }
    &__descr {
      color: #121212;
      background: #d8d8d8;
      flex: 0 0 50%;
      height: auto;
      margin: 0;
      padding: 0;
      align-items: flex-start;
      justify-content: center;
      padding: 0 1.8em;
    }
    &__category {
      color: #9a9a9a !important;
    }
    .data-news {
      color: #9a9a9a !important;
    }
  }
  .card-2,
  .card-4 {
    flex-direction: row-reverse;
  }
}
@media screen and (max-width: 767px) {
  .fourth-bar {
    margin-top: 3rem;
    margin-bottom: 3rem;
    width: 100%;
    overflow-x: hidden;
  }
  .grid {
    width: 100%;
  }
  .card {
    &__descr {
      justify-content: space-between;
      padding: 0;
      background: transparent !important;
      backdrop-filter: blur(0px);
      min-height: auto;
    }
    &__title {
      display: flex;
      align-items: center;
      height: 100%;
      color: #fff;
      background: rgba(85, 85, 85, 0.8);
      .limited-text {
        --snup: 4 !important;
      }
    }
  }
  .card-1,
  .card-3 {
    .card__img {
      margin-left: 5%;
    }
    .card__title {
      padding-right: 5%;
      padding-left: 0.5rem;

      position: relative;
      width: 110%;
      left: -20%;
    }
  }

  .card-2,
  .card-4 {
    .card__img {
      margin-right: 5%;
    }
    .card__descr {
      position: relative;
      left: 10%;
    }
    .card__title {
      padding-left: 10%;
      padding-right: 0.5rem;
      position: relative;
      color: #121212;
      background: rgba(248, 248, 248, 0.91);
      width: 120%;
      left: -10%;
    }
  }
}
</style>
